/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React from 'react';
import PropTypes from 'prop-types';
import utils from '../../utils/utils';
import './style.less';

class PipelineHotspots extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imageShow: false,
    };
    this.bodyWidth = typeof window !== "undefined" ? window.document.body.clientWidth : 750;
  }

  componentDidMount() {
    this.imageLoadedAll();
  }

  handleItemClick = (item, index) => {
    let jumpUrl = '';
    if (item.productType === '商品库') {
      jumpUrl = `shihuo://www.shihuo.cn?route=goodsDetail&id=${item.id}&styleId=${item.styleId}`
    } else {
      jumpUrl = item.link;
    }    
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: jumpUrl,
        props: this.props,
        index
      })
      return
    }
    const baseConfig = this.props.config.baseConfig;
    const options = {
      link: jumpUrl,
      type: baseConfig.sortType,
      sort: index,
    };
    if (item.productType === "商品库") {
      options.goods_id = item.id;
      options.style_id = item.styleId;
    }
    utils.jumpToUrl(this.props.routeParams,jumpUrl,'',options,-1,this.props);
  };

  render() {
    const { baseConfig, itemList } = this.props.config;
    const { sortType, backgroundImage, backgroundTitleImage } = baseConfig;
    let className = "", classNameTitle = "";
    switch (sortType) {
      case "热区排列一":
        className = "display-type1 item-pro"
        classNameTitle = "background-title1-image"
        break;
      case "热区排列二":
        className = "display-type2 item-pro"
        classNameTitle = "background-title2-image"
        break;
      case "热区排列三":
        className = "display-type3 item-pro"
        classNameTitle = "background-title3-image"
        break;
      default:
        break;
    }
    return (
      <div
        className="pipeline-hotspots"
        {...this.props['customAttributes']}
      >
        <img
          className="background-image"
          src={utils.formatImgUrl(backgroundImage, this.props.webpSupport)}
        />
        {
          backgroundTitleImage ? (
            <img
              className={classNameTitle}
              src={utils.formatImgUrl(backgroundTitleImage, this.props.webpSupport)}
            />
          ) : null
        }
        {itemList.map((item, index) => {
          return this.state.imageShow ? (
            <div className={className} key={index} onClick={this.handleItemClick.bind(this, item, index)}>
              <img src={utils.formatImgUrl(item.src, this.props.webpSupport)} alt="" className="image" style={{width: this.bodyWidth * 0.26}} />
            </div>
          ) : null
        })}
      </div>
    );
  }

  // 图片全部加载完成
  imageLoadedAll = () => {
    const { itemList } = this.props.config;
    let mulitImg = itemList.map((item, index) => {
      return item.src;
    });
    let promiseAll = [], img = [], imgTotal = mulitImg.length;
    for (let i = 0; i < imgTotal; i++) {
      promiseAll[i] = new Promise((resolve, reject) => {
        img[i] = new Image();
        img[i].src = mulitImg[i];
        img[i].onload = function() {
          //第i张加载完成
          resolve(img[i]);
        };
      });
    }
    Promise.all(promiseAll).then(img => {
      //全部加载完成
      this.setState({
        imageShow: true,
      });
    });
  };
}

PipelineHotspots.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineHotspots };
export default PipelineHotspots;



// WEBPACK FOOTER //
// ./components/pipeline-hotspots/index.js